import {
    ClockCircleOutlined,
    MedicineBoxOutlined,
    CalendarOutlined,
} from '@ant-design/icons';

// Medicine Dosage Options
export const MEDICINE_DOSAGE_OPTIONS = [
    { value: '1 - 0 - 0', label: '1-0-0' },
    { value: '0 - 1 - 0', label: '0-1-0' },
    { value: '0 - 0 - 1', label: '0-0-1' },
    { value: '1 - 0 - 1', label: '1-0-1' },
    { value: '1 - 1 - 0', label: '1-1-0' },
    { value: '0 - 1 - 1', label: '0-1-1' },
    { value: '1 - 1 - 1', label: '1-1-1' },
    { value: '2 - 2 - 2', label: '2-2-2' },
    { value: '1 - 1- 1 - 1', label: '1-1-1-1' },
    { value: 'SOS', label: 'SOS' }
];

// Medicine Timing Options
export const MEDICINE_TIMING_OPTIONS = [
    { value: 'Before Meal', label: 'Before Meal' },
    { value: 'After Meal', label: 'After Meal' },
    { value: 'With Meal', label: 'With Meal' },
    { value: 'With Milk', label: 'With Milk' },
    { value: 'Empty Stomach', label: 'Empty Stomach' },
    { value: 'At Bedtime', label: 'At Bedtime' },
    { value: 'At Morning', label: 'At Morning' },
    { value: 'At Night', label: 'At Night' },
    { value: 'Morning & Night', label: 'Morning & Night' },
    { value: 'Morning & Afternoon', label: 'Morning & Afternoon' },
    { value: 'Afternoon & Night', label: 'Afternoon & Night' },
    { value: 'Any Time', label: 'Any Time' }
];

// Filter Options
export const DATE_FILTER_OPTIONS = [
    { label: 'Today', value: 'today' },
    { label: 'Last 7 Days', value: 'last7days' },
    { label: 'Last 30 Days', value: 'last30days' },
    { label: 'This Month', value: 'thisMonth' },
    { label: 'Last Month', value: 'lastMonth' },
    { label: 'Custom Range', value: 'custom' }
];